/* ============================================================
   Collection Rotator behaviour.
   Vanilla JS reimplementation of a center-mode product carousel:
   - scroll-snap rail, closest-to-center item becomes "active"
   - clicking any item smooth-scrolls it to center
   - prev/next arrows step one item at a time
   - active item's data-cine-colour recolors the mood shape
   - tabs swap which collection's rail is shown
   ============================================================ */
(function () {
  'use strict';

  function initScroller(root) {
    var shape = root.querySelector('[data-cine-shape]');
    var tabs = root.querySelectorAll('[data-cine-tab]');
    var prevBtn = root.querySelector('[data-cine-prev]');
    var nextBtn = root.querySelector('[data-cine-next]');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function activeTrack() {
      return root.querySelector('.cine-scroller__track.is-active');
    }

    function updateActive(rail) {
      if (!rail) return;
      var items = rail.querySelectorAll('.cine-scroller__item');
      if (!items.length) return;

      var railRect = rail.getBoundingClientRect();
      var center = railRect.left + railRect.width / 2;
      var closest = null;
      var closestDist = Infinity;

      items.forEach(function (item) {
        var r = item.getBoundingClientRect();
        var itemCenter = r.left + r.width / 2;
        var dist = Math.abs(itemCenter - center);
        if (dist < closestDist) {
          closestDist = dist;
          closest = item;
        }
        item.classList.remove('is-active');
      });

      if (closest) {
        closest.classList.add('is-active');
        var colour = closest.getAttribute('data-cine-colour');
        if (shape && colour) {
          shape.style.backgroundColor = 'rgb(' + colour + ')';
        }
      }
    }

    function scrollToItem(rail, item) {
      var railRect = rail.getBoundingClientRect();
      var itemRect = item.getBoundingClientRect();
      var delta = (itemRect.left + itemRect.width / 2) - (railRect.left + railRect.width / 2);
      rail.scrollBy({ left: delta, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    function wireRail(rail) {
      if (!rail || rail.dataset.cineWired) return;
      rail.dataset.cineWired = 'true';

      var raf = null;
      rail.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          updateActive(rail);
          raf = null;
        });
      }, { passive: true });

      rail.addEventListener('click', function (e) {
        var item = e.target.closest('.cine-scroller__item');
        if (!item || item.classList.contains('is-active')) return;
        e.preventDefault();
        scrollToItem(rail, item);
      });

      // Initial paint once images/layout settle.
      requestAnimationFrame(function () { updateActive(rail); });
      window.addEventListener('resize', function () { updateActive(rail); }, { passive: true });
    }

    function step(direction) {
      var track = activeTrack();
      var rail = track && track.querySelector('[data-cine-rail]');
      if (!rail) return;
      var current = rail.querySelector('.cine-scroller__item.is-active');
      var items = Array.prototype.slice.call(rail.querySelectorAll('.cine-scroller__item'));
      var idx = current ? items.indexOf(current) : 0;
      var nextIdx = Math.min(Math.max(idx + direction, 0), items.length - 1);
      if (items[nextIdx]) scrollToItem(rail, items[nextIdx]);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var targetId = tab.getAttribute('data-cine-tab');

        tabs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        root.querySelectorAll('.cine-scroller__track').forEach(function (track) {
          var isMatch = track.getAttribute('data-cine-panel') === targetId;
          track.classList.toggle('is-active', isMatch);
          track.hidden = !isMatch;
        });

        var rail = activeTrack() && activeTrack().querySelector('[data-cine-rail]');
        if (rail) {
          wireRail(rail);
          requestAnimationFrame(function () { updateActive(rail); });
        }
      });
    });

    var initialRail = activeTrack() && activeTrack().querySelector('[data-cine-rail]');
    if (initialRail) wireRail(initialRail);
  }

  function init() {
    document.querySelectorAll('.cine-scroller').forEach(initScroller);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var scroller = e.target.querySelector && e.target.querySelector('.cine-scroller');
      if (scroller) initScroller(scroller);
    });
  }
})();
